import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import PropTypes from 'prop-types';
var BaseNavItemPropType = {
  icon: PropTypes.string,
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string.isRequired
};
export var NavLinkPropType = _objectSpread(_objectSpread({}, BaseNavItemPropType), {}, {
  url: PropTypes.any
});

var NavDropdownPropType = _objectSpread(_objectSpread({}, BaseNavItemPropType), {}, {
  children: PropTypes.arrayOf(PropTypes.shape(NavLinkPropType))
});

export var NavItemPropType = PropTypes.shape(_objectSpread(_objectSpread({}, NavDropdownPropType), NavLinkPropType));